import { useIsOnSemanticSearch } from '@hooks/use-is-on-semantic-search';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { appliedFiltersFormattedAtom } from '../containers/FilterPills/atoms';
import { orderRecentlySeenDirectories } from '../helpers/recentlySearchedDirectories';

const getSemanticSearchFromUrl = (): string | null => {
	if (typeof window === 'undefined') return null;

	const urlParams = new URLSearchParams(window.location.search);
	const query = urlParams.get('q');

	// Return the query if it exists and is not empty
	return query && query.trim().length > 0 ? query.trim() : null;
};

export const useOrderRecentlySeenDirectories = () => {
	const { marketCode, category, city, stateCode } = useAppSelector((state) => ({
		marketCode: state.search.marketCode,
		category: state.category,
		city: state.location.city,
		stateCode: state.location.stateCode,
	}));
	const appliedFiltersFormatted = useAtomValue(appliedFiltersFormattedAtom);
	const { isOnSemanticSearch } = useIsOnSemanticSearch();

	// Record the search when page loads or when URL-based search parameters change
	// Read the semantic search directly from URL query parameters to avoid typing results
	useEffect(() => {
		const semanticSearchQuery = isOnSemanticSearch
			? getSemanticSearchFromUrl()
			: null;

		orderRecentlySeenDirectories({
			marketCode,
			category: category.code,
			city,
			stateCode,
			appliedFilterPills: appliedFiltersFormatted,
			semanticSearch: semanticSearchQuery,
		});
	}, [
		marketCode,
		category.code,
		city,
		stateCode,
		appliedFiltersFormatted,
		isOnSemanticSearch,
	]);
};
